export enum InviteStatus {
  Active = 'ACTIVE',
  Revoked = 'REVOKED',
  Expired = 'EXPIRED',
  Exhausted = 'EXHAUSTED',
}
